const simulationMonitorLogHu = {
	simulationMonitorLogTable: 'Simulation Monitor Log',
	name: 'Name',
	simulationMonitorLogEditForm: 'Simulation Monitor Log',
	tableName: 'Table Name',
	description: 'Description',
	basic: 'Basic',
	fields: 'Fields',
	type: 'Type'
};

export default simulationMonitorLogHu;